import { getUnsavedAttributeValue } from '@pages/QuoteDetails/helpers/getUnsavedAttributeValue';
import { UnsavedChangesSlice } from '@store/types/UnsavedChangesSlice.type';

export function getStructuredQuoteWithUnsavedValues({
  structuredQuote,
  storedAttributes,
  quoteItemId,
}: {
  structuredQuote: any;
  storedAttributes: UnsavedChangesSlice['attributesById'];
  quoteItemId?: string;
}): any {
  if (!structuredQuote || Object.keys(storedAttributes).length === 0) {
    return structuredQuote;
  }

  return {
    ...structuredQuote,
    quoteItems: (structuredQuote.quoteItems ?? []).map((qi: any) => {
      if (quoteItemId && qi.id !== quoteItemId) {
        return qi;
      }

      const attributeTypes = Object.fromEntries(
        Object.entries(qi.attributeTypes ?? {}).map(([codeName, attributeType]: [string, any]) => {
          const persistedAttributeId = attributeType.attribute?.id;
          const draftAttributeId = `${qi.id}-${attributeType.id}`;
          const lookupId = persistedAttributeId ?? draftAttributeId;
          const unsavedAttribute = storedAttributes[lookupId];

          if (!unsavedAttribute) {
            return [codeName, attributeType];
          }

          const field = {
            id: attributeType.id,
            attribute: persistedAttributeId ? { id: persistedAttributeId } : undefined,
            dataType: attributeType.dataType,
            uiFieldType: attributeType.uiFieldType,
          };

          const value = getUnsavedAttributeValue(storedAttributes, field, qi.id, 'value');
          const valueOverride = getUnsavedAttributeValue(storedAttributes, field, qi.id, 'valueOverride');
          const existingAttribute = attributeType.attribute ?? {};

          return [
            codeName,
            {
              ...attributeType,
              attribute: {
                ...existingAttribute,
                ...unsavedAttribute,
                ...(value !== undefined ? { value } : {}),
                ...(valueOverride !== undefined ? { valueOverride } : {}),
                id: lookupId,
                isLocked: unsavedAttribute.isLocked ?? existingAttribute.isLocked ?? null,
                isUpdatedByUser: unsavedAttribute.isUpdatedByUser ?? existingAttribute.isUpdatedByUser ?? null,
              },
            },
          ];
        }),
      );

      return {
        ...qi,
        attributeTypes,
      };
    }),
  };
}
